import { EditRemoveActions, type DataGridConfig } from '@eo/shared';

import type { ClientItem } from '../api/types';

type ClientsGridArgs = { onRemove: (row: ClientItem) => void };

export function makeClientsGridConfig({ onRemove }: ClientsGridArgs): DataGridConfig<ClientItem> {
  return {
    getRowId: (row) => row.id,
    paramPrefix: 'cl_',
    rowTestId: 'owned-client-row',
    pagination: false,
    emptyState: { title: 'No clients assigned to this member.' },
    columns: [
      { id: 'name', header: 'Client', accessor: (row) => row.name },
      {
        id: 'isActive',
        header: 'Active',
        align: 'center',
        accessor: (row) => (row.isActive ? 'Yes' : '—'),
      },
      {
        id: 'actions',
        header: '',
        align: 'right',
        accessor: () => null,
        cell: (row) => (
          <EditRemoveActions row={row} onRemove={onRemove} removeLabel={`Unassign ${row.name}`} />
        ),
      },
    ],
  };
}
